import * as React from 'react';
import type { SVGProps } from 'react';

const SvgIconGraph = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={19} fill="none" {...props}>
    <path
      fill="#D04237"
      d="M22.235 0H1.425A.693.693 0 0 0 .73.694v17.342a.693.693 0 0 0 .693.694h20.811a.694.694 0 0 0 .694-.694V.694A.693.693 0 0 0 22.235 0Zm-.693 17.343H2.118V1.387h19.424v15.956ZM6.627 14.537a2.06 2.06 0 0 0 1.655-3.282l2.244-3.343a2 2 0 0 0 1.325-.108l2.795 2.98a2.057 2.057 0 1 0 3.403-.378l1.887-4.187a.694.694 0 1 0-1.266-.569l-1.828 4.062a2.01 2.01 0 0 0-1.183.139l-2.788-2.997a2.057 2.057 0 1 0-3.892-.937c0 .44.143.868.406 1.221L7.14 10.482a2.201 2.201 0 0 0-.513-.076 2.06 2.06 0 1 0 0 4.117v.014Zm10.524-2.817a.673.673 0 1 1-1.346 0 .673.673 0 0 1 1.346 0Zm-6.122-6.472a.673.673 0 1 1-.673.67.666.666 0 0 1 .673-.67Zm-4.402 6.545a.673.673 0 1 1 0 1.345.673.673 0 0 1 0-1.345Z"
    />
  </svg>
);
export default SvgIconGraph;
